export default "__VITE_ASSET__Bx2X7ZTY__"